export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-foreground-900 via-foreground-800 to-foreground-950 p-8 md:p-12">
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-accent-500/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

          <div className="relative z-10 flex flex-col md:flex-row items-center gap-8 md:gap-12">
            <div className="flex-shrink-0 w-32 h-32 md:w-40 md:h-40 rounded-3xl bg-background-50/10 backdrop-blur flex items-center justify-center border border-background-50/15">
              <i className="ri-smartphone-line text-5xl md:text-6xl text-accent-400"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-background-50 mb-3">
                随时随地，吃瓜不停
              </h2>
              <p className="text-sm text-background-300/80 leading-relaxed mb-6">
                下载吃瓜爆料 APP，第一时间接收每日热点爆料吃瓜推送。支持 iOS 与 Android 双平台，
                海量吃瓜爆料视频随时随地观看，吃瓜爆料每日大赛精彩内容同步更新，让你不错过任何一个热门爆料。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
                <a href="#app" className="w-full sm:w-auto px-6 py-3 bg-background-50 text-foreground-900 font-semibold rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap text-center cursor-pointer text-sm">
                  <i className="ri-apple-fill mr-2"></i>iOS 下载
                </a>
                <a href="#app" className="w-full sm:w-auto px-6 py-3 bg-background-50/15 text-background-50 font-semibold rounded-lg border border-background-50/20 hover:bg-background-50/25 transition-colors whitespace-nowrap text-center cursor-pointer text-sm">
                  <i className="ri-android-fill mr-2"></i>Android 下载
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}